
import Loading from '@components/common/Loading';
import { API_URL } from '@redux/api';
import { useEffect, useState } from 'react';
import { InventoryItemLoading, InventoryItemObject, Item } from 'react-app-env'

type Props = {
  inventories: InventoryItemLoading[]
};

type SingleItemData = {
	item: {
    _id: string;
    name: string;
		category: {
			_id: string;
      name: string;
		};
    quantity: number,
    unit: string;
    image: string;
  },
  loading_quantity: number,
  loading_unit: string;
  loading_trip: number,
  _id: string;
};

const ItemCard = ({ data }: { data: SingleItemData }) => {
  
  const { loading_quantity, loading_unit } = data;

  return (
    <div className='border border-gray-200 bg-white rounded-xl p-3'>
      <div className='flex items-center gap-2'>
        <img 
          src={`${API_URL}/images/inventories/${data.item.category.name}/${data.item.image}`}
          onError={({currentTarget}: any) => {
            currentTarget.onerror = null;
            currentTarget.src = `${API_URL}/images/no-image.webp`;
          }}
          alt=""
          className='w-[50px] h-auto'
        />
        <div>
          <h2 className='capitalize font-semibold'>{data.item.name}</h2>
          <label>Jumlah : <strong>{loading_quantity} {loading_unit}</strong></label>
        </div>
      </div>
    </div>
  );
};

const ItemList = ({
  inventories
}: Props) => {

  const [listItems, setListItems] = useState<InventoryItemObject | null>()

  useEffect(() => {
    let itemsGroupByCategory: any = {};
    
    inventories.forEach(inv => {
      const { item, quantity, trip, unit } = inv;

      const categoryName = item.category.name;
      if (!itemsGroupByCategory[categoryName]) {
        itemsGroupByCategory[categoryName] = [];
      };

      itemsGroupByCategory[categoryName].push({
        item,
        loading_quantity: quantity,
        loading_trip: trip,
        loading_unit: unit
      });
    });

    setListItems(itemsGroupByCategory);
  
    return () => {}
  }, [inventories]);
  
  return (
    <div>
      {listItems ? 
        Object.keys(listItems).reverse().map(key => {
          const items: Item[] = listItems[key];
          const label = key.charAt(0).toUpperCase() + key.slice(1);

          return (
            <div key={key} className="bg-white mb-4 rounded-xl overflow-hidden px-4">
              <div className='py-4'>
                <h6 className='font-semibold text-center lg:text-left'>{label}</h6>
              </div>
              <div className='pb-4 pt-0 lg:py-4 lg:border-t grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                {items.map((data: any) => {
                  return (
                    <ItemCard key={`inventory-${data.item._id}`} data={data} />
                  )
                })}
              </div>
            </div>
          )
        })
        : <div>
          <Loading loading={true} type='beat-loader' size={10} parentClass='text-sm' />
        </div>
      }
    </div>
  )
}

export default ItemList